import { ReportHandlerFactory } from "./handlers/ReportHandlerFactory";

/**
 * Generates and downloads an Excel report from standardized report data.
 * Refactored to use Strategy pattern via ReportHandlerFactory.
 */
export const downloadAccountingExcel = async (jsonContent) => {
    if (!jsonContent) return;

    try {
        const handler = ReportHandlerFactory.getHandler(jsonContent);
        await handler.downloadExcel();
    } catch (error) {
        console.error("Error generating Excel report:", error);
    }
};
